<div class="flex flex-col p-6 w-full h-full relative">
    <div class="flex justify-between items-center pb-6">
        <h2 class="text-lg font-semibold text-gray-900">Add Appointment</h2>
        <img [src]="assetUrl + 'icons/x-close.svg'" class="w-5 h-5 cursor-pointer" alt="Close" (click)="onClosePopup()">
    </div>

    <div class="flex flex-col w-full flex-grow justify-between ">
        @if(loading){
        <app-loader></app-loader>
        }
        <!-- Step 2 -->
        <!-- <div class="flex flex-col flex-grow">
            <div class="flex items-center gap-4 pb-4">
                <div class="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-sm font-semibold text-gray-600">
                    DW
                </div>
                <span class="text-sm font-medium text-gray-900">Dian Wilkinson</span>
            </div>

            <div class="flex flex-col gap-2 pb-4">
                <div class="flex items-center gap-2 text-sm text-gray-600">
                    <img [src]="assetUrl + 'icons/calendar.svg'" class="w-4 h-4" />
                    <span>Fri, 08 Mar 2025</span>
                </div>
                <div class="flex items-center gap-2 text-sm text-gray-600">
                    <img [src]="assetUrl + 'icons/clock.svg'" class="w-4 h-4" />
                    <span>09:00 AM (2 hours duration)</span>
                </div>
            </div>

            <div class="pb-6">
                <span class="flex items-center gap-2 text-sm text-gray-700 border border-gray-200 rounded-full px-3 py-1 w-fit">
                    <img [src]="assetUrl + 'icons/tag-avatar.png'" class="w-5 h-5 rounded-full object-cover" />
                    Service by <b>Helen</b>
                </span>
            </div>

            <div class="flex flex-col gap-3 pb-6">
                <div class="flex justify-between items-center border border-gray-200 rounded-xl p-4">
                    <div class="flex flex-col text-sm">
                        <span class="font-medium text-gray-900">Haircut</span>
                        <span class="text-gray-600">1 hr, 30 mins</span>
                    </div>
                    <span class="font-semibold text-sm text-gray-900">$15,00</span>
                </div>

                <div class="flex justify-between items-center border border-gray-200 rounded-xl p-4">
                    <div class="flex flex-col text-sm">
                        <span class="font-medium text-gray-900">Hair Coloring</span>
                        <span class="text-gray-600">1 hr, 30 mins</span>
                    </div>
                    <span class="font-semibold text-sm text-gray-900">$15,00</span>
                </div>

                <div class="flex justify-end pt-1">
                    <glo-button icon="plus-dark" type="white" value="Add Service"></glo-button>
                </div>
            </div>
        </div>

        <div class="flex justify-between items-center pt-4 pb-6 text-sm font-medium text-gray-900">
            <span>Total</span>
            <span>$30,00</span>
        </div> -->


        <!-- Step1 -->
        <form class="flex flex-col gap-5" [formGroup]="AppointmentForm">
            <label class="flex flex-col text-sm text-gray-800 ">
                <!-- Select Date -->
                <!-- <glo-control type="calendar" [value]='appointmentDate.value'
                    (valueChange)="onChange($event, 'appointmentDate')" icon="calendar" placeholder="MM/DD/YYYY"
                    (blur)="onBlur()"></glo-control> -->

                <app-glo-date-picker [formControlInput]="appointmentDate" [label]="'Select Date'"
                    [placeholder]="'Choose date'"></app-glo-date-picker>
                @if(appointmentDate.hasError('pattern') && appointmentDate.touched){
                <span class="text-red-500 text-sm mt-1">Please enter a vaild date</span>
                } @else if(appointmentDate.hasError('required') && appointmentDate.touched){
                <span class="text-red-500 text-sm mt-1">Date is required</span>
                }
                <!-- <app-glo-date-picker placeholder="MM/DD/YYYY" [(value)]="selectedDate"></app-glo-date-picker> -->
            </label>

            <label class="flex flex-col text-sm text-gray-800">
                Time
                <glo-control type="select" [value]="AppointmentForm.get('start_time')?.value"
                    (valueChange)="onChange($event, 'start_time')" [showKey]="'Name'" [valueKey]="'id'"
                    [options]="timeSlots" placeholder="12:00 AM"></glo-control>
                @if(AppointmentForm.get('start_time')?.touched &&
                AppointmentForm.get('start_time')?.hasError('required')){
                <span class="text-red-500 text-sm mt-1">Time is required</span>
                }
            </label>

            <label class="flex flex-col text-sm text-gray-800">
                Saloon
                <glo-control type="select" [value]="AppointmentForm.get('saloonId')?.value"
                    (valueChange)="onChange($event, 'saloonId')" [showKey]="'name'" [valueKey]="'salon_id'"
                    [options]="Saloons" placeholder="Select"></glo-control>
                @if(AppointmentForm.get('saloonId')?.touched &&
                AppointmentForm.get('saloonId')?.hasError('required')){
                <span class="text-red-500 text-sm mt-1">Saloon is required</span>
                }
            </label>

            <label class="flex flex-col text-sm text-gray-800">
                Client name
                <glo-control type="select" [value]="AppointmentForm.get('customerId')?.value"
                    (valueChange)="onChange($event, 'customerId')" [showKey]="'full_name'" [valueKey]="'customer_id'"
                    [options]="Customer" placeholder="Select"
                    [isDisabled]="AppointmentForm.get('saloonId')?.hasError('required') ? true : false">
                </glo-control>
                @if(AppointmentForm.get('customerId')?.touched &&
                AppointmentForm.get('customerId')?.hasError('required')){
                <span class="text-red-500 text-sm mt-1">Client is required</span>
                }
            </label>

            <label class="flex flex-col text-sm text-gray-800">
                Handle By
                <glo-control type="select" [value]="AppointmentForm.get('handleById')?.value"
                    (valueChange)="onChange($event, 'handleById')" [showKey]="'full_name'" [valueKey]="'staff_id'"
                    [options]="Staff" placeholder="Select"
                    [isDisabled]="AppointmentForm.get('saloonId')?.hasError('required') ? true : false"></glo-control>

            </label>
            <label class="flex flex-col text-sm text-gray-800">
                Select Service
                <glo-control type="select" [value]="AppointmentForm.get('service_ids')?.value"
                    (valueChange)="onChange($event, 'service_ids')" [showKey]="'name'" [valueKey]="'service_id'"
                    [options]="Services" [placeholder]="'Select'" [classes]="'bg-gray-400'"
                    [isDisabled]="AppointmentForm.get('saloonId')?.hasError('required') ? true : false"></glo-control>
                @if(AppointmentForm.get('service_ids')?.touched &&
                AppointmentForm.get('service_ids')?.hasError('required')){
                <span class="text-red-500 text-sm mt-1">Service is required</span>
                }
            </label>


        </form>
        <!-- Footer Buttons fixed at bottom -->
        <div class="flex pt-6 border-t border-gray-200 justify-end gap-4 mt-auto">
            <button class="px-6 py-2 shadow rounded-3xl bg-white text-gray-950" (click)="onClosePopup()">Cancel</button>
            <button type="submit" class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white"
                (click)="handleSubmit()">Save</button>
        </div>
    </div>
</div>